import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { ToasterService } from "angular2-toaster";
import { CommonService } from "../../../common/commonService";
import { urlConstant } from "../../../constant/urlConstant";
import { MatDialog } from "@angular/material";
import { ShareProformaInvoiceComponent } from "../share-proforma-invoice/share-proforma-invoice.component";

@Component({
  selector: "app-receipt",
  templateUrl: "./receipt.component.html",
  styleUrls: ["./receipt.component.scss"],
})
export class ReceiptComponent implements OnInit {
  propertyId: any;
  loginUserDetail: any;
  recepintList: any[] = [];
  billTypeList: any[] = [];
  userDetailList: any[] = [];
  selectedRecepint = "";
  userDetail: any = {};
  propertyData: any = {};

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public _CommonService: CommonService,
    public toasterService: ToasterService,
    public dialog: MatDialog
  ) {
    this.propertyId = this.route.snapshot.params.id;
  }

  ngOnInit() {
    this.loginUserDetail = this._CommonService.getLoggedInUser();
    this.getParamType();
    this.getUserList();
    if (!!this.loginUserDetail) {
      this.getPropertyByPropertyId();
    }
  }

  getParamType() {
    this._CommonService
      .get<any>(
        urlConstant.PropertyStatus.getParamByType +
          "?type=" +
          "Payment Recipient"
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.recepintList = res.data.paramList;
        }
      });

    this._CommonService
      .get<any>(
        urlConstant.PropertyStatus.getParamByType + "?type=" + "BillType"
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.billTypeList = res.data.paramList;
        }
      });
  }

  getUserList() {
    this._CommonService
      .get<any>(
        urlConstant.BillUtility.allUsersByPropertyId +
          "?propertyId=" +
          this.propertyId
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.userDetailList = res.data.userList;
          this.userDetailList.map((val: any) => {
            if (val.roleId === 111) {
              this.selectedRecepint = String(
                this.recepintList
                  .filter(
                    (ele: any) =>
                      String(ele.paramValue).toLowerCase() ===
                      String(val.roles[0].name).toLowerCase()
                  )
                  .map((val: any) => val.paramValue)
              );
              this.userDetail = val;
            }
          });
        }
      });
  }

  getPropertyByPropertyId() {
    this._CommonService
      .get<any>(
        urlConstant.Property.GetPropertyByPropertyId +
          "?propertyId=" +
          this.propertyId
      )
      .subscribe((res: any) => {
        if (res.Status === "200") {
          this.propertyData = res.data.Property;
        }
      });
  }

  shareInvoice() {
    this.dialog.open(ShareProformaInvoiceComponent, {});
  }
}
